/* eslint-disable react/prop-types */
import React from 'react'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { components } from 'react-select'

export const SECURE = 'secure'

export const filterHelper = (compliantDataToFilter, nonCompliantField, filterOptions) => {
  if (filterOptions?.length) {
    // eslint-disable-next-line no-param-reassign
    compliantDataToFilter = compliantDataToFilter.filter((nonCompliant) =>
      filterOptions.some((option) => option.value === nonCompliant[`${nonCompliantField}`]),
    )
  }
  return compliantDataToFilter
}

export function Option({ children, ...props }) {
  const { isSelected, label, value, isMulti, data } = props

  const onClick = (e) => {
    props.selectOption({ ...data })
    e.stopPropagation()
    e.preventDefault()
  }

  if (isMulti) {
    return (
      <components.Option {...props}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div className="multi-select-option" onClick={onClick}>
          <Form.Check readOnly className="multi-select-check" checked={isSelected} label={label} value={value} />
          {
            // Show count in option if not showing employees
            props.selectProps.name !== 'employee' && <span className="multi-select-count">{props.data.count}</span>
          }
        </div>
      </components.Option>
    )
  }
}

export const formatColumn = (cell, row, key) => <span>{row?.[key]}</span>

// eslint-disable-next-line consistent-return
export const formatArrayColumn = (cell, row, key) => {
  if (row?.[key]) {
    const returnArray = []
    let collapsed = ''

    for (let i = 0; i < row[key].length; i += 1) {
      // Ignore empty values (no chip) needs to be there for searching
      if (row[key] === 'empty') {
        break
      }
      if (i < 2) {
        returnArray.push(
          <div key={i} className="chip">
            {row[key][i]}
          </div>,
        )
      } else {
        collapsed += !collapsed.length ? row[key][i] : `, ${row[key][i]}`
      }
    }

    if (row[key][0] === 'empty') {
      return []
    }

    const renderTooltip = (props) => (
      <Tooltip id="button-tooltip" {...props}>
        {collapsed}
      </Tooltip>
    )

    if (row[key].length > 2) {
      returnArray.push(
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
          <div key={2} className="chip">
            +{row[key].length - 2}
          </div>
        </OverlayTrigger>,
      )
    }
    return returnArray
  }
}
